import { DateSelected } from './Calendar';

export interface LocalBusinesses {
    id?: number;
    legalName?: string;
    timezone?: string;
    enabled?: string;
    journey?: boolean;
    city?: string;
    organization?: number;
    organizationName?: string;
    zipcode?: string;
    instalationDate?: DateSelected;
    range?: any;
    isCegid?: boolean;
    attractivityEnabled?: boolean;
    groupsCountingEnabled?: boolean;
    ageGenderEnabled: boolean;
    localBusinessFiancial?: any;
    openingCalendar?: {
        [key: string]: { openingTime?: string; closingTime?: string };
    };
}
